import React, { useContext, useState } from 'react';
import { Box, SxProps, TextField, useTheme } from '@mui/material';
import IconSearch from 'shared/icons/search';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { useSearchParams } from 'react-router-dom';
import { useSearchParamsUtils } from 'app/hooks/useSearchParamsUtils';
import { observer } from 'mobx-react-lite';
import { SortingValue } from 'shared/lib/components/controls/sorting/sortingControl';
import CustomTextField from 'shared/lib/components/controls/textFields/customTextField';

export default observer(function SearchBar({
  placeholder = '',
  sx,
}: {
  placeholder?: string;
  sx?: SxProps;
}) {
  const theme = useTheme();
  const {
    spacings: { sp },
    getFontSize,
  } = useContext(UiContext);
  const { sort, search } = useSearchParamsUtils();
  const [searchParams, setSearchParams] = useSearchParams();

  const f16 = getFontSize('f16');

  return (
    <Box
      sx={{
        'display': 'flex',
        'justifyContent': 'space-between',
        'width': 1,
        'boxShadow': '0px 0px 8px 0px rgba(134, 134, 134, 0.30)',
        'borderRadius': 100,
        'overflow': 'hidden',
        '& *': {
          fontSize: `${f16} !important`,
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            border: 'none',
          },
          '&:hover fieldset': {
            border: 'none',
          },
          '&.Mui-focused fieldset': {
            border: 'none',
          },
        },
        '& .MuiInputBase-root': {
          px: sp.s70,
        },
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none !important',
        },
        ...sx,
      }}
    >
      <CustomTextField
        wrapperSxProps={{
          flexGrow: 1,
          backgroundColor: theme.palette.secondary.main,
        }}
        isClearIcon={true}
        id="search_input"
        InputProps={{
          startAdornment: (
            <IconSearch
              style={{ minWidth: 16, minHeight: 16, marginRight: sp.s40 }}
              sizeKey="20x20"
              extColor={theme.palette.custom.lightGrey}
            ></IconSearch>
          ),
        }}
        placeholder={placeholder}
        value={search || ''}
        onChange={(e) => {
          setSearchParams((curr) => {
            if (e.target.value) {
              curr.set('search', e.target.value);
              curr.set('sort', sort || SortingValue.CREATING_DEC);
            } else {
              curr.delete('search');
              curr.delete('sort');
            }
            return curr;
          });
        }}
      ></CustomTextField>
    </Box>
  );
});
